import React from "react";
import ReactDOM from "react-dom/client";
import { loadConfig } from "./config";
import App from "./App";

loadConfig()
  .then(() => {
    ReactDOM.createRoot(document.getElementById("root")!).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  })
  .catch((err) => {
    document.getElementById("root")!.innerHTML =
      `<pre style="color:red;padding:2rem">Failed to load config.json:\n${err}</pre>`;
  });
